import { useTranslation } from "react-i18next";

const show = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "object") return JSON.stringify(value);
  if (typeof value === "boolean") return String(value);
  return String(value);
};

// One entry in a change log (branch or employee).
export const BranchHistoryRow = ({ entry, ns = "branches.history" }) => {
  const { t } = useTranslation();
  const when = new Date(entry.at);
  return (
    <li className="rounded-2xl p-3 shadow-neu-in" data-testid={`change-log-${entry.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-2">
        <p className="text-sm font-bold">{entry.actor_name || entry.actor_email || "—"}</p>
        <p className="font-mono text-[11px] text-muted-foreground" dir="ltr">
          {when.toLocaleString("en-GB", { hour12: false })}
        </p>
      </div>
      <p className="mt-1 text-[11px] font-bold text-primary">{t(`${ns}.action.${entry.action}`)}</p>
      {(entry.changes || []).length ? (
        <ul className="mt-2 grid gap-1 font-mono text-[11px]">
          {entry.changes.map((c) => (
            <li key={c.field} className="flex flex-wrap gap-1">
              <span className="font-bold">{t(`${ns}.field.${c.field}`, { defaultValue: c.field })}:</span>
              <span className="text-muted-foreground line-through">{show(c.from)}</span>
              <span aria-hidden="true">→</span>
              <span>{show(c.to)}</span>
            </li>
          ))}
        </ul>
      ) : null}
    </li>
  );
};
